import React from 'react'
import getUid from '../utils/uidGenerator'

class TextArea extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            input : undefined,
            label: this.props.label
        }

        this.uid = getUid();
    }

    handleOnChange = (i) => {
        let taVal = i.target.value;
        this.setState({ input: taVal });
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(i);
        }
    }

    clearTextArea = () => {
        document.getElementById(this.uid).value = "";
    }

    render() {
        return (
            <div className={("js-floating-label ci-floating-label ci-textarea") + (this.state.input ? " ci-label-floating" : "")}>
                <textarea name="input1" id={this.uid} className="ci-input-element" onChange={this.handleOnChange}></textarea>
                <label htmlFor={this.uid}>
                    {this.props.label}
                </label>
                {!this.props.dontShowValidationStatus &&
                    <div className="ci-validation-status" />
                }
            </div>
        )
    }
}

export default TextArea